import { render, staticRenderFns } from "./BrockerDealerSetConcentrationModal.vue?vue&type=template&id=9a30d4dc&scoped=true&"
import script from "./BrockerDealerSetConcentrationModal.vue?vue&type=script&lang=js&"
export * from "./BrockerDealerSetConcentrationModal.vue?vue&type=script&lang=js&"
import style0 from "./BrockerDealerSetConcentrationModal.vue?vue&type=style&index=0&id=9a30d4dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a30d4dc",
  null
  
)

export default component.exports